// src/index.js

import React from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { OrderProvider } from './context/OrderContext';
import { NetworkProvider } from './context/NetworkContext';
import { SocketProvider } from './context/SocketContext';
import { initializeAnalytics } from './utils/analytics';
import { register as registerServiceWorker } from './serviceWorkerRegistration';
import { initNativeShell, hideSplash } from './native/bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Import Bootstrap JS (includes Popper.js)

initializeAnalytics();
registerServiceWorker();
// No-ops on web; wires status bar / back button / keyboard inside the
// native Capacitor shell. See src/native/bootstrap.js.
initNativeShell();

const root = createRoot(document.getElementById('root'));
root.render(
	<React.StrictMode>
		<ChakraProvider value={defaultSystem}>
			<NetworkProvider>
				<SocketProvider>
					<AuthProvider>
						<OrderProvider>
							<App />
						</OrderProvider>
					</AuthProvider>
				</SocketProvider>
			</NetworkProvider>
		</ChakraProvider>
	</React.StrictMode>
);

// Hide the native launch splash once the first paint is done. rAF after the
// render call is enough to avoid a white flash between splash and content.
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
	requestAnimationFrame(() => requestAnimationFrame(() => { hideSplash(); }));
} else {
	hideSplash();
}
